<template>
  <div class="w-full">
    <div class="form-group px-2">
      <label for="selected_owner" class="form-label">Odaberi tvrtku</label>
      <v-select id="selected_owner"
                v-model="selectedOwner"
                label="title"
                name="owner"
                :options="allOwners"
                :multiple="true"
      >
        <template slot="no-options">
          Pretraživanje tvrtke
        </template>
      </v-select>
    </div>

    <div class="form-group px-2">
      <label for="selected_status" class="form-label">Odaberi status</label>
      <v-select id="selected_status"
                v-model="selectedStatus"
                label="title"
                :options="allStatus"
                :multiple="true"
      >
        <template slot="no-options">
          Pretraživanje po statusu
        </template>
      </v-select>
    </div>

    <div class="flex justify-between px-2 mt-8">
      <div class="pr-2 w-1/2">
        <datepicker class="test" input-class="form-control" placeholder="Datum kreiranja od:" :language="hr" v-model="selectedCreatedDateFrom"></datepicker>
      </div>

      <div class="pl-2 w-1/2">
        <datepicker input-class="form-control " placeholder="Datum kreiranja do:" :language="hr" v-model="selectedCreatedDateTo"></datepicker>
      </div>
    </div>
    <div class="flex justify-between px-2 mt-8">
      <div class="pr-2 w-1/2">
        <datepicker class="test" input-class="form-control" placeholder="Datum planiranog završetka od:" :language="hr" v-model="selectedPlannedEndDateFrom"></datepicker>
      </div>

      <div class="pl-2 w-1/2">
        <datepicker input-class="form-control " placeholder="Datum planiranog završetka do:" :language="hr" v-model="selectedPlannedEndDateTo"></datepicker>
      </div>
    </div>
    <div class="flex justify-between px-2 mt-8">
      <div class="pr-2 w-1/2">
        <datepicker class="test" input-class="form-control" placeholder="Datum završetka od:" :language="hr" v-model="selectedFinishedDateFrom"></datepicker>
      </div>

      <div class="pl-2 w-1/2">
        <datepicker input-class="form-control " placeholder="Datum završetka do:" :language="hr" v-model="selectedFinishedDateTo"></datepicker>
      </div>
    </div>

    <div class="flex justify-between mt-4">
      <button @click="exportFiltered" class="btn btn-export text-lg border-hl_yellow hover:border-yellow mt-6">
        <span>Izvoz podataka</span>
      </button>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import {hr} from 'vuejs-datepicker/dist/locale'

export default {
name: "ModalExportRolloutLabWorkOrder",
  props: {
    locations: {
      type: Array,
      default: () => ([])
    },

    owners: {
      type: Array,
      default: () => ([])
    },

    status: {
      type: Array,
      default: () => ([])
    },
  },

  components: {
    vSelect,
    Datepicker,
  },

  mounted() {
  },

  data() {
    return {
      allOwners: this.owners,
      allLocations: this.locations,
      allStatus: this.status,
      selectedLocation: [],
      selectedOwner: [],
      selectedStatus: [],
      selectedCreatedDateFrom: '',
      selectedCreatedDateTo: '',
      selectedPlannedEndDateFrom: '',
      selectedPlannedEndDateTo: '',
      selectedFinishedDateFrom: '',
      selectedFinishedDateTo: '',
      hr: hr,

    }
  },

  methods: {
    exportFiltered() {
      let filterData = []

      if (this.selectedLocation) {
        let locationIds = []
        this.selectedLocation.forEach((location) => {
          locationIds.push(location.id)
        })
        filterData.location = locationIds
      }

      if (this.selectedOwner) {
        let ownerIds = []
        this.selectedOwner.forEach((owner) => {
          ownerIds.push(owner.id)
        })
        filterData.owner = ownerIds
      }

      if (this.selectedStatus) {
        filterData.status = this.selectedStatus
      }


      if (this.selectedCreatedDateFrom) filterData.selectedCreatedDateFrom = this.selectedCreatedDateFrom
      if (this.selectedCreatedDateTo) filterData.selectedCreatedDateTo = this.selectedCreatedDateTo
      if (this.selectedPlannedEndDateFrom) filterData.selectedPlannedEndDateFrom = this.selectedPlannedEndDateFrom
      if (this.selectedPlannedEndDateTo) filterData.selectedPlannedEndDateTo = this.selectedPlannedEndDateTo
      if (this.selectedFinishedDateFrom) filterData.selectedFinishedDateFrom = this.selectedFinishedDateFrom
      if (this.selectedFinishedDateTo) filterData.selectedFinishedDateTo = this.selectedFinishedDateTo

      window.location = route('admin.rollout-work-order.export', { data: filterData })
    },
  }
}
</script>

